import smileysSymbols from '../smileys';
import weatherSymbols from '../weather';
import musicSymbols from '../music';
import mathematicalSymbols from '../math';
import currencySymbols from '../currencies';
import numeralSymbols from '../numerals';
import arrowsSymbols from '../arrows';
import heartsSymbols from '../hearts';
import chessSymbols from '../chess';

const allEmojis = [
  heartsSymbols,
  arrowsSymbols,
  numeralSymbols,
  currencySymbols,
  mathematicalSymbols,
  musicSymbols,
  weatherSymbols,
  smileysSymbols,
  chessSymbols,
];

export default allEmojis;
